import { z } from "zod";
import { entityBaseSchema, slugSchema } from "./common.js";

/**
 * Tester guidance frontmatter — `iamu/guidance/<slug>.md` (CONTRACT §5).
 *
 * A rule the walker follows on later runs: what not to report
 * (`not_relevant`) or what it tends to misread (`walker_error`). The body
 * is the rule text, optionally followed by a `## Reason` section. Scope
 * names a capability or scenario outline by local slug; the push envelope
 * carries the resolved ids in `refs.capability_id` / `refs.outline_id`.
 * Mirrors the `tester_guidance` table in the cloud schema.
 */
export const guidanceFrontmatterSchema = entityBaseSchema.extend({
  kind: z.enum(["out_of_scope", "not_relevant", "walker_error"]),
  status: z.enum(["active", "retired"]).default("active"),
  scope: z
    .object({
      capability: slugSchema.optional(),
      outline: slugSchema.optional(),
    })
    .default({}),
  /** Canonical findings whose dismissal produced the rule. */
  source_canonical_ids: z.array(z.string().uuid()).default([]),
});

export type GuidanceFrontmatter = z.infer<typeof guidanceFrontmatterSchema>;
